import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/store.js';
import cv from './utils/number-validator.js';
import $axios from './http/http-svs';
import JsonExcel from 'vue-json-excel';
import '@babel/polyfill';
import './assets/css/normalize.css';

import './assets/font/font.css';
import './assets/css/public.css';
import './assets/css/common.scss';
import './assets/css/date-picker.css';
import './assets/css/animate.min.css';
import './assets/css/theme/theme-dark.scss';
import ECharts from 'vue-echarts/components/ECharts.vue';
import { loading, scrollBoard } from '@jiaminghi/data-view';
import Int from './comon/directive/validate';
import Letter from './comon/directive/validate_letter';
import ElementUI from 'element-ui'
import i18n from '@/lang/index';
import "./comon/directive/permission";
Vue.use(ElementUI, {
    i18n: (key, value) => i18n.t(key, value)
  })  
Vue.directive('Int', Int);
Vue.directive('Letter', Letter);
Vue.use(loading);
Vue.use(scrollBoard);
import VueCookie from 'vue-cookie';
Vue.component('v-chart', ECharts);
Vue.component('downloadExcel', JsonExcel);
Vue.config.productionTip = false;
Vue.use(VueCookie);
Vue.prototype.$axios = $axios;
Vue.prototype.$cv = cv;
Vue.prototype.bus = new Vue();
Vue.filter('formatMoney', function(value) {
    return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
});
const that = new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app');

export default that;